// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2IUom","dragIcon":"Choice_dragIcon__2-49Y","left":"Choice_left__3S02b","input":"Choice_input__3HVqV"};